export class IOppRequest {
  engagementId!: string;
}
